export default __webpack_public_path__ + "static/media/de.08ac8cd2.svg";